import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitChangePassword } from '../../../Actions/Login.action';
import { translate } from '../../../Services/translation';
import Input from '../../Input';
import clsx from 'clsx';

const LoginChangePassword = () => {
  const { isLoading, username = '', password = '' } = useSelector(
    (state) => state.login
  );
  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const dispatch = useDispatch();

  const onSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(
      submitChangePassword(
        username,
        password,
        newPassword,
        passwordConfirmation
      )
    );
  };

  return (
    <>
      <form onSubmit={onSubmit} className="login__form">
        <Input
          label={translate('general.password')}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder={translate('general.password')}
          type="password"
          disabled={isLoading}
        />
        <Input
          label={translate('login.confirm-password')}
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          placeholder={translate('login.confirm-password')}
          type="password"
          disabled={isLoading}
        />
        <button
          className="login__submit-button"
          type="submit"
          disabled={isLoading}
        >
          {translate(isLoading ? 'general.loading' : 'general.send')}
        </button>
      </form>
    </>
  );
};

export default LoginChangePassword;
